import { render, staticRenderFns } from "./NurseList.vue?vue&type=template&id=2382fee4&"
import script from "./NurseList.vue?vue&type=script&lang=js&"
export * from "./NurseList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports